export const faqs = [
  {
    id: 1,
    question: '韩国漫画网是免费的吗？',
    answer: '是的，韩国漫画网上的所有韩漫均为免费在线阅读。我们致力于为广大韩漫爱好者提供高质量的免费漫画内容，无需付费即可畅享阅读体验。',
  },
  {
    id: 2,
    question: '什么是下拉式阅读模式？',
    answer: '下拉式阅读模式是韩国漫画特有的一种阅读方式。您只需向下滚动页面，漫画内容便会连续流畅地呈现，无需点击翻页按钮，让阅读体验更加自然顺畅。这种模式特别适合手机端阅读。',
  },
  {
    id: 3,
    question: '漫画多久更新一次？',
    answer: '我们与多家韩国漫画平台保持合作，热门连载漫画通常每周更新一至两话。首页的「最近更新」区域会实时展示最新的漫画章节，您也可以在每部漫画的详情页查看具体的更新时间。',
  },
  {
    id: 4,
    question: '如何在手机上看韩国漫画？',
    answer: '韩国漫画网采用响应式设计，完美适配手机、平板和电脑端。您只需在手机浏览器中打开我们的网站，即可享受流畅的下拉式阅读体验，无需下载任何App。',
  },
  {
    id: 5,
    question: '网站上有哪些类型的韩国漫画？',
    answer: '我们收录了恋爱、奇幻、动作、悬疑、校园、穿越、耽美、竞技等多种类型的韩国漫画，目前共有超过500部作品供您选择。您可以通过顶部的分类导航快速找到感兴趣的漫画类型。',
  },
  {
    id: 6,
    question: '可以下载漫画到本地吗？',
    answer: '目前韩国漫画网支持在线浏览功能，暂不提供下载服务。但我们持续优化的阅读体验确保您在任何网络环境下都能流畅阅读。',
  },
];